import {useGet, useQueryWithErrorHandling} from '@app/sdk';
import { Search } from '../../FakeAccessPayClient';
import { useQueryClient } from '@tanstack/react-query';

export function useGetReports({ reportType, accessPayBaseUrl, serviceUserNumber }: { reportType: string, accessPayBaseUrl: string, serviceUserNumber: string }) {
  const get = useGet();

  async function getReports() {
    return await get<{ reports: Search[] }>(`${accessPayBaseUrl}reports?reportType=${reportType}&serviceUserNumber=${serviceUserNumber}`).then(
      (x) => x.reports
    );
  }

  return useQueryWithErrorHandling({
    queryKey: ['getReports', serviceUserNumber, reportType ],
    queryFn: getReports,
    enabled: !!reportType && !!accessPayBaseUrl,
  });
}

export function useRefreshReports() {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({
      queryKey: ['getReports'],
    });
  };
}
